import Layout from "@/components/feature/Layout";
import PlotHeader from "./components/PlotHeader";
import EndingAnalysis from "./components/EndingAnalysis";
import ArticleList from "./components/ArticleList";

function Plot() {
  return (
    <Layout>
      <title>嘿咻嘿咻漫画剧情解析 - 结局分析、章节导读与伏笔盘点</title>
      <meta
        name="description"
        content="嘿咻嘿咻漫画剧情解析专栏：包含开篇导读、主线分析、大结局深度解析与伏笔盘点，帮你快速理清故事脉络、读懂结局走向。"
      />
      <meta
        name="keywords"
        content="嘿咻嘿咻漫画剧情,嘿咻嘿咻漫画结局,嘿咻嘿咻漫画剧情解析,伏笔盘点"
      />
      <link rel="canonical" href="https://characterz2.github.io/plot" />

      <PlotHeader />
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <EndingAnalysis />
        <ArticleList />
      </div>
    </Layout>
  );
}

export default Plot;